import Head from "next/head";
import { defaultMetatags } from "@/lib/constants";

function createValue(value, key) {
  if (value) {
    return value;
  } else {
    const defaultValue = key
      .split(".")
      .reduce((acc, v) => acc?.[v], defaultMetatags?.["vod"]);
    return defaultValue;
  }
}

export function MetaTag({ title, keywords, description }) {
  const titleValue = createValue(title, "title", "vod");
  const keywordsContent = createValue(keywords, "keywords");
  const descriptionContent = createValue(description, "description");
  return (
    <Head>
      <title key="title">{titleValue}</title>
      <meta name="keywords" content={keywordsContent} key="keywords" />
      <meta name="description" content={descriptionContent} key="description" />
    </Head>
  );
}

export function Og({ type, title, description, url, image }) {
  const titleContent = createValue(title, "og.title");
  const ogurl = (() => {
    if (typeof window !== "undefined") {
      return window.location.href;
    } else {
      return url || defaultMetatags["vod"].og.url;
    }
  })();
  const descriptionContent = createValue(description, "og.description");
  const imageContent = createValue(image, "og.image");

  return (
    <Head>
      <meta property="og:title" content={titleContent} key="ogtitle" />
      <meta property="og:url" content={ogurl} key="ogurl" />
      <meta property="og:type" content={type} key="ogtype" />
      <meta
        property="og:description"
        content={descriptionContent}
        key="ogdescription"
      />
      <meta property="og:image" content={imageContent} key="ogimage" />
    </Head>
  );
}

export function TwitterCard({ title, description, card, image }) {
  const titleContent = createValue(title, "twitter.title");
  const descriptionContent = createValue(description, "twitter.description");
  const imageContent = createValue(image, "twitter.image");
  return (
    <Head>
      <meta name="twitter:title" content={titleContent} key="twittertitle" />
      <meta
        name="twitter:description"
        content={descriptionContent}
        key="twitterdescription"
      />
      <meta name="twitter:card" content={card} key="twittercard" />
      <meta name="twitter:image" content={imageContent} key="twitterimage" />
    </Head>
  );
}

export function Robots({ content }) {
  if (!content) return null;
  return (
    <Head>
      <meta name="robots" content={content} key="robots" />
    </Head>
  );
}

export function CanonicalUrl({ href }) {
  if (!href) return null;
  return (
    <Head>
      <link rel="canonical" href={href} />
    </Head>
  );
}

export default function MetaTags({
  title,
  keywords,
  description,
  og,
  twitter,
  robots,
  canonicalUrl,
}) {
  return (
    <>
      <MetaTag {...{ title, keywords, description }} />
      <Og {...{ description, ...og }} />
      <TwitterCard {...{ ...twitter, description }} />
      <Robots content={robots} />
      <CanonicalUrl href={canonicalUrl} />
    </>
  );
}
